export default "__VITE_ASSET__DcWOzhNA__"